import { ROUTES } from '@/config/routes';

import { setSessionNotice } from './sessionNotice';
import { tokenStorage } from './tokenStorage';

let ending = false;

/**
 * Ends the session and sends the person to sign in.
 *
 * <h2>Why a hard navigation rather than the router</h2>
 *
 * This is called from an interceptor, outside React, where there is no `navigate`
 * to reach. Routing it back through a context would mean a module the whole
 * application imports depending on a provider being mounted — and this runs
 * precisely when things are going wrong, which is the worst time to add that
 * requirement.
 *
 * <p>A full reload also discards every cache and every piece of component state
 * in one step, which is exactly what should happen when a session ends: nothing
 * loaded as the previous user survives.
 *
 * <h2>Once, however many requests failed</h2>
 *
 * A dashboard fires several requests at once; when a session ends they all fail
 * together. Without the guard each one navigates, and the person watches the page
 * reload repeatedly.
 *
 * <h2>The message</h2>
 *
 * Optional, and stored for the sign-in screen to pick up — see
 * {@link setSessionNotice} for why `sessionStorage` rather than the URL. The guard
 * above covers it too: the first caller's reason wins, which is the right one,
 * since every later caller is the same session ending.
 *
 * @param message why the session ended, shown once on the sign-in screen
 */
export function onSessionEnded(message?: string): void {
  if (ending) {
    return;
  }
  ending = true;

  if (message !== undefined) {
    setSessionNotice(message);
  }
  tokenStorage.clear();
  window.location.assign(ROUTES.signIn);
}

/** For tests, which must not inherit another test's guard. */
export function resetSessionState(): void {
  ending = false;
}
